import React, { useState, useEffect } from "react";
import axios from "axios";

function App() {
  const API = "https://api.czlowiekbezksywy.pl/api";

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [waterState, setWaterState] = useState("Zamknięta");
  const [drainState, setDrainState] = useState("Zamknięty");
  const [loadingWater, setLoadingWater] = useState(false);
  const [loadingDrain, setLoadingDrain] = useState(false);

  // Sprawdzenie zapisanych danych
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const storedPass = localStorage.getItem("pass");
    if (storedUser && storedPass) {
      setUsername(storedUser);
      setPassword(storedPass);
      setIsLoggedIn(true);
  //    fetchStates(storedUser, storedPass);
    }
  }, []);

  // Logowanie
  const handleLogin = (e) => {
    e.preventDefault();
    if (!username || !password) return alert("Podaj login i hasło!");
    localStorage.setItem("user", username);
    localStorage.setItem("pass", password);
    setIsLoggedIn(true);
    //fetchStates(username, password);
  };

  // Wylogowanie
  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("pass");
    setIsLoggedIn(false);
    setUsername("");
    setPassword("");
  };

  useEffect(() => {
    if (!isLoggedIn || !username || !password) return;

    let isMounted = true;

    const fetchState = async () => {
      try {
        const res = await axios.get(`${API}/state`, {
          headers: {
            "Authorization": "Basic " + btoa(`${username}:${password}`)
          },
          withCredentials: true,
        });

        if (!isMounted) return;

        console.log('Response data:', res.data);

        const { main, spust } = res.data;

        // Woda
        switch (main) {
          case "ON":
            setWaterState("Otwarta");
            break;
          case "WAIT_FOR_DRAIN_CLOSE":
            setWaterState("Czekam na zamknięcie spustu");
            break;
          default:
            setWaterState("Zamknięta");
        }

        // Spust
        switch (spust) {
          case "ON":
            setDrainState("Otwarty");
            break;
          case "WAIT_FOR_MAIN_CLOSE":
            setDrainState("Czekam na zamknięcie głównego zaworu");
            break;
          default:
            setDrainState("Zamknięty");
        }

      } catch (error) {
        console.error("Błąd podczas pobierania stanu:", error);
      }
    };

    fetchState();
    const interval = setInterval(fetchState, 1000);
    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, [isLoggedIn, username, password]);


  // --- Wysyłanie komend przez API ---
  const sendCommand = async (command, setLoading) => {
    setLoading(true);
    try {
      await axios.post(`${API}/${command}`, {}, {
        headers: { 
		"Content-Type": "application/json", 
		"Authorization": "Basic " + btoa(`${username}:${password}`) 
	},
        withCredentials: true, // jeśli chcesz wysyłać cookies / credentials
      });
      console.log(`Wysłano: ${command}`);
    } catch (err) {
      alert("Błąd API: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  // --- Toggle wody ---
  const toggleWater = () => {
    if (loadingDrain || loadingWater || waterState === "Czekam na zamknięcie spustu" || drainState == "Czekam na zamknięcie głównego zaworu" || waterState === "W trakcie") return;

    const command = waterState !== "Otwarta" ? "main/open" : "main/close";
    setWaterState("W trakcie");
    sendCommand(command, setLoadingWater);
  };

  // --- Toggle spustu ---
  const toggleDrain = () => {
    if (loadingDrain || loadingWater  || waterState === "Czekam na zamknięcie spustu" || drainState == "Czekam na zamknięcie głównego zaworu" ||  drainState === "W trakcie") return;

    const command = drainState !== "Otwarty" ? "spust/open" : "spust/close";
    setDrainState("W trakcie");
    sendCommand(command, setLoadingDrain);
  };

  // --- Style przełączników ---
  const switchStyle = (disabled) => ({
    display: "inline-block",
    width: "60px",
    height: "30px",
    borderRadius: "15px",
    position: "relative",
    backgroundColor: disabled ? "#eee" : "#ccc",
    cursor: disabled ? "not-allowed" : "pointer",
    margin: "10px",
  });

  // --- Knob: pełna mapa stanów ---
  const knobStyle = (type, state) => {
    let left = "3px";
    let backgroundColor = "#fff";

    if (type === "water") {
      switch (state) {
        case "Otwarta":
          left = "33px";
          backgroundColor = "#4caf50"; // zielony
          break;
        case "Zamknięta":
          left = "3px";
          backgroundColor = "#fff";
          break;
        case "Czekam na zamknięcie spustu":
          left = "33px";
          backgroundColor = "#ff9800"; // pomarańczowy
          break;
        case "W trakcie":
          left = "33px";
          backgroundColor = "#ff9800"; // pomarańczowy
          break;
        default:
          left = "3px";
          backgroundColor = "#ccc";
      }
    }

    if (type === "drain") {
      switch (state) {
        case "Otwarty":
          left = "33px";
          backgroundColor = "#4caf50"; // zielony
          break;
        case "Zamknięty":
          left = "3px";
          backgroundColor = "#fff";
          break;
        case "W trakcie":
          left = "33px";
          backgroundColor = "#ff9800"; // pomarańczowy
          break;
        default:
          left = "3px";
          backgroundColor = "#ccc";
      }
    }

    return {
      position: "absolute",
      top: "3px",
      left,
      width: "24px",
      height: "24px",
      borderRadius: "50%",
      backgroundColor,
      transition: "all 0.3s ease",
    };
  };


  if (!isLoggedIn) {
    return (
      <div style={{ textAlign: "center", marginTop: "100px" }}>
        <h1>Logowanie 🔑</h1>
        <form onSubmit={handleLogin}>
          <input placeholder="Login" value={username} onChange={e=>setUsername(e.target.value)} /><br/><br/>
          <input type="password" placeholder="Hasło" value={password} onChange={e=>setPassword(e.target.value)} /><br/><br/>
          <button type="submit">Zaloguj</button>
        </form>
      </div>
    );
  }

  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h1>Zawory 💧</h1>
      <button onClick={handleLogout}>Wyloguj</button>

      <div>
        <h2>Woda: {waterState}</h2>
        <div
          style={switchStyle(loadingWater || loadingDrain || waterState === "Czekam na zamknięcie spustu" || waterState === "W trakcie")}
          onClick={toggleWater}
        >
          <div style={knobStyle("water", waterState)}></div>
        </div>
      </div>

      <div>
        <h2>Spust: {drainState}</h2>
        <div
          style={switchStyle(loadingDrain || loadingWater || drainState == "Czekam na zamknięcie głównego zaworu" || drainState === "W trakcie")}
          onClick={toggleDrain}
        >
          <div style={knobStyle("drain", drainState)}></div>
        </div>
      </div>

      <p style={{ marginTop: "40px" }}>
        <a href={`${API}/ping`} target="_blank" rel="noreferrer">
          🔍 Sprawdź status API
        </a>
      </p>
    </div>
  );
}

export default App;

